import Heading from "../ui/Heading.jsx";

function Contact() {
    return (
        <div className="pt-10 mx-auto w-full max-w-2xl px-4">
            <Heading className="text-center font-bold mb-4">
                Contact Us
            </Heading>
            <p className={"text-center text-gray-600"}>
                Got the goss on an upcoming party we should know about?
            </p>
            <p className="text-center text-gray-600">
                Or have some feedback on making{" "}
                <strong>UnicorNation</strong>{" "}
                even better?
            </p>

            <p className="text-center text-gray-600 mt-2">
                Email us directly at{" "}
                <a
                    href="mailto:contact@unicornation.com.au?subject=Unicornation%20Feedback"
                    className="font-medium text-pink-500 hover:text-pink-600 underline"
                >
                    contact@unicornation.com.au
                </a>
            </p>
        </div>
    );
}

export default Contact;
